function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4438",
  "data-name": "Caminho 4438",
  d: "M110.395,437.835a1.231,1.231,0,0,0-1.231,1.233v10.814H91.341V439.068a1.238,1.238,0,0,0-1.24-1.233,1.224,1.224,0,0,0-1.224,1.233v12.047a1.228,1.228,0,0,0,1.224,1.23h20.294a1.234,1.234,0,0,0,1.224-1.23V439.068a1.23,1.23,0,0,0-1.224-1.233Zm5.5-.175h0l-14.756-14.739-.018-.017a1.2,1.2,0,0,0-1.738,0L84.605,437.66a1.229,1.229,0,0,0,0,1.738,1.212,1.212,0,0,0,1.739,0l13.9-13.891,13.9,13.891a1.222,1.222,0,0,0,1.747,0,1.244,1.244,0,0,0,0-1.738Z",
  transform: "translate(-84.245 -422.531)",
  fill: "#35424b"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29.814,
    viewBox: "0 0 32 29.814",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.d554debd.svg";
export { ForwardRef as ReactComponent };